<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/periodicidade">
        Cadastro/Servico Periodicidade
      </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center-left">
          <v-col cols="12" sm="6" md="3" class="text-left">
            <v-text-field
              label="Período"
              v-model.number="quantidadeHoras"
              class="compact-input"
              type="number"
              :rules="[
                rules.naoNegativo,
                (v) => !!v || 'O período é obrigatório',
              ]"
              required
            />
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/periodicidade" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarPeriodicidadeAsync } from "../../../services/periodicidadeService";
import { mapState } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroPlanoManutencao";

export default {
  name: "criarPeriodicidade",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    quantidadeHoras: false,
    active_tab: 3,
    rules: {
      naoNegativo: (v) =>
        v === null || v === "" || v >= 0 || "Não pode ser negativo",
    },
  }),
  computed: {
    ...mapState("periodicidade", ["periodicidades"]),
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarPeriodicidadeAsync(
          this.descricao,
          this.quantidadeHoras
        );
        if (resposta == null || resposta.status != 200) {
          this.overlay = false;
          this.$alert(resposta.message || '', "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/periodicidade");
        }
      }
    },
  },
  components: {
    TabNavegacao,
  },
};
</script>
